import { FC, ReactNode } from 'react'

import { cn } from '@bem-react/classname'

import './Tag.scss'

interface ITagProps {
  className?: string
  children: ReactNode
}

const cnTag = cn('Tag')

export const Tag: FC<ITagProps> = ({ className, children }): JSX.Element => {
  return <div className={cnTag(null, [className])}>{children}</div>
}
